import store from '../../vue/vuex/store'

const setWechatShare = function() {
        let title = store.state.wechatShare.title
        let desc = store.state.wechatShare.desc
        let imgUrl = store.state.wechatShare.imgUrl
        let link = store.state.wechatShare.link
        /** 分享到朋友圈
         * 参数: 标题 图标 链接?
         */
        wx.onMenuShareTimeline({
                title: title, // 分享标题
                link: link, // 分享链接，该链接域名必须与当前企业的可信域名一致
                imgUrl: imgUrl, // 分享图标
                success: function() {
                    // 用户确认分享后执行的回调函数
                    // alert("成功分享到朋友圈")
                },
                cancel: function() {
                    // 用户取消分享后执行的回调函数
                    // alert("取消分享到朋友圈")
                }
            })
            /** 分享给朋友
             * 参数: 标题 描述 图标 链接?
             */
        wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接，该链接域名必须与当前企业的可信域名一致
            imgUrl: imgUrl, // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function() {
                // alert("成功分享给朋友")
                // 用户确认分享后执行的回调函数
            },
            cancel: function() {
                // alert("取消分享给朋友")
                // 用户取消分享后执行的回调函数
            }
        })
    }

const hideMenuItems = function() {
        wx.hideMenuItems({
            menuList: ["menuItem:favorite", "menuItem:editTag", "menuItem:copyUrl", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:readMode", "menuItem:share:brand"], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
            fail: function() {
                // alert("减少按钮失败!")
            }
        })
    }

const showMenuItems = function() {
        wx.showMenuItems({
            menuList: ["menuItem:share:appMessage", "menuItem:share:timeline","menuItem:share:qq", "menuItem:share:QZone"], // 要显示的菜单项，所有menu项见附录3
            fail: function() {
                // alert("增加按钮失败!")
            }
        })
    }
    
const chooseImage = function(){
        wx.chooseImage({
            count: 1, // 默认9
            sizeType: ['original', 'compressed'], // 能够指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 能够指定来源是相冊还是相机，默认二者都有
            success: function (res) {
                var localIds = res.localIds; // 返回选定照片的本地ID列表，localId能够作为img标签的src属性显示图片
            }
        });
    }

export default {
	install(Vue) {
		Vue.prototype.$setWechatShare = setWechatShare,
		Vue.prototype.$hideMenuItems = hideMenuItems,
        Vue.prototype.$showMenuItems = showMenuItems,
        Vue.prototype.$chooseImage = chooseImage
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/WeiXin.js